import React from "react";

export interface SessionExpiredDialogProps {
  onLoginAgain: () => void;
  onLogout: () => void;
  className?: string;
}

/** Default modal. Replace via `AuthProvider`'s `sessionExpiredDialogComponent` prop. */
export function SessionExpiredDialog({ onLoginAgain, onLogout, className }: SessionExpiredDialogProps) {
  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="fka-session-expired-title"
      className="fka-dialog-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black/70"
    >
      <div
        className={
          className ??
          "fka-dialog w-full max-w-sm rounded-lg border border-slate-800 bg-slate-900 p-6 text-center"
        }
      >
        <h2 id="fka-session-expired-title" className="fka-dialog-title mb-2 text-lg font-semibold text-slate-100">
          Your session has expired.
        </h2>
        <p className="fka-dialog-body mb-6 text-sm text-slate-400">
          For your security, you've been signed out. Sign in again to continue.
        </p>
        <div className="fka-dialog-actions flex justify-center gap-3">
          <button
            onClick={onLoginAgain}
            className="fka-dialog-primary rounded-md bg-amber-500 px-4 py-2 text-sm font-medium text-slate-950 hover:bg-amber-400"
          >
            Login Again
          </button>
          <button
            onClick={onLogout}
            className="fka-dialog-secondary rounded-md border border-slate-700 px-4 py-2 text-sm text-slate-300 hover:bg-slate-800"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}
